import { useEffect, useRef, useState } from "react";
import { Feature, View } from "ol";
import { fromLonLat } from "ol/proj";
import TileLayer from "ol/layer/Tile";
import OSM from 'ol/source/OSM';
import olMap from 'ol/Map';
import VectorImageLayer from "ol/layer/VectorImage";
import VectorSource from "ol/source/Vector";
import { Button } from "@mui/material";
import { variables } from "../../styles/abstract/variables";
import moment from "moment";
import { Point } from "ol/geom";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Circle from "ol/style/Circle";

function ReportMap({ parcel, photos, year }) {
  const mapInstance = useRef();
  const [ready, setReady] = useState(null);
  const initMap = () => {

   

    
    mapInstance.current = new olMap({
      pixelRatio: window.devicePixelRatio < 1 ? 1 : window.devicePixelRatio,
      target: document.querySelector('#map'),
      interactions: [],
      layers: [
        new TileLayer({
          source: new OSM()
        }),
        new VectorImageLayer({
          source: new VectorSource({
            features: [parcel.getFeature()]
          })
        }),
      ],
      view: new View({
        zoom: 2,
        center: fromLonLat([25, 40])
      })

    });

    parcel.zoomTo(mapInstance.current.getView())

    mapInstance.current.once('rendercomplete', () => {
      const mapCanvas = document.createElement('canvas');
      const size = mapInstance.current.getSize();
      mapCanvas.width = size[0];
      mapCanvas.height = size[1];
      const mapContext = mapCanvas.getContext('2d');
      Array.prototype.forEach.call(
        mapInstance.current.getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-layer'),
        function (canvas) {
          if (canvas.width > 0) {
            const opacity =
              canvas.parentNode.style.opacity || canvas.style.opacity;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            let matrix;
            const transform = canvas.style.transform;
            if (transform) {
              // Get the transform parameters from the style's transform matrix
              matrix = transform
                .match(/^matrix\(([^\(]*)\)$/)[1]
                .split(',')
                .map(Number);
            } else {
              matrix = [
                parseFloat(canvas.style.width) / canvas.width,
                0,
                0,
                parseFloat(canvas.style.height) / canvas.height,
                0,
                0,
              ];
            }
            // Apply the transform to the export map context
            CanvasRenderingContext2D.prototype.setTransform.apply(
              mapContext,
              matrix,
            );
            const backgroundColor = canvas.parentNode.style.backgroundColor;
            if (backgroundColor) {
              mapContext.fillStyle = backgroundColor;
              mapContext.fillRect(0, 0, canvas.width, canvas.height);
            }
            mapContext.drawImage(canvas, 0, 0);
          }
        },
      );
      mapContext.globalAlpha = 1;
      mapContext.setTransform(1, 0, 0, 1, 0, 0);

      setTimeout(() => {
        mapInstance.current.updateSize();
        setReady(mapCanvas.toDataURL());

      }, 100)
    });
  }

  useEffect(() => {
    initMap();


    return () => {
      mapInstance.current.setTarget(null)
    }
  }, [])

  if (ready) {
    return (
      <div style={{ position: 'relative', marginBottom: '40px' }}>
        <img width="100%" style={{ boxShadow: '1px 0px 5px 1px rgba(0,0,0, 0.3)' }} src={ready} />
      </div>
    );
  }

  return <div id="map" style={{ height: '400px', boxShadow: '1px 0px 5px 1px rgba(0,0,0, 0.3)' }}></div>
}

export default ReportMap;